import useFormApi from "@data-driven-forms/react-form-renderer/use-form-api";
import React, { useEffect, useState } from "react";
import { Grid } from "@mui/system";
import { Button } from "@mui/material";
import { ElementType } from "react";

interface CustomFormTemplateProps {
  formFields: ElementType[],
  onSubmit: (data: any) => void;
}

export const ProductFormTemplate = ({ formFields, onSubmit }: CustomFormTemplateProps) => {
  const { getState, change } = useFormApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!isSubmitting) return;
    const { values } = getState();
    if (values.productName) {
      change('slug', values.productName.replace(/\s+/g, '-').toLowerCase());
    }
    const { values: updatedValues } = getState();
    onSubmit(updatedValues);
  }, [isSubmitting]);

  return (
    <form
      style={{
        width: '600px'
      }}
      onSubmit={(event) => {
        event.preventDefault();
        setIsSubmitting(true);
      }}
    >
      <Grid container justifyContent="space-between" spacing={1}>
        {formFields}
      </Grid>
      <Button variant={'contained'} onClick={e => setIsSubmitting(!isSubmitting)}>Submit</Button>
    </form>
  );
};
